/**
 * Checks if a given string length is too big
 *
 * @param {string} name
 * @param {number} length
 * @return {boolean}
 */
export function maxStringLength(name?: string, length?: number): boolean {
  if (name === undefined) {
    return false;
  }
  const maxLength = length;
  return maxLength! >= name.length;
}
